export default "__VITE_ASSET__f06ed56b__"